import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { debugLog } from "../../Utils/utils";
import {
  sendReferralOtp,
  verifyReferralOtp,
  referralLink,
  resendReferralOtp,
  fetchReferralStats,
} from "../Thunks/ReferralThunk";

const sendOtpSuccessMessage = "OTP has been sent to your email";
const verifyOtpSuccessMessage = "OTP verified successfully";

export const referralSlice = createSlice({
  name: "referral",
  initialState: {
    isLoading: false,
    isSending: false,
    isVerifying: false,
    isResending: false,
    otpValidate: false,
    referralData: null,
    referralHistory: [],
    totalReferralCount: 0,
    totalReferralEarnings: 0,
    referralLink: "",
    referralStatus: "IN_ACTIVE",
    error: null,
  },
  reducers: {
    clearReferralError: (state) => {
      state.error = null;
    },
    resetReferralState: (state) => {
      state.referralData = null;
      state.error = null;
      state.otpValidate = false;
      state.referralStatus = "IN_ACTIVE";
    },
    setOtpValidate: (state, action) => {
      state.otpValidate = action.payload;
    },
    setReferralHistory: (state, action) => {
      state.referralHistory = action.payload;
    },
    setReferralLink: (state, action) => {
      state.referralLink = action.payload;
    },
    setReferralStatus: (state, action) => {
      state.referralStatus = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Send OTP
    builder.addCase(sendReferralOtp.pending, (state) => {
      state.isSending = true;
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(sendReferralOtp.fulfilled, (state, action) => {
      state.isSending = false;
      state.isLoading = false;
      toast.success(sendOtpSuccessMessage);
    });
    builder.addCase(sendReferralOtp.rejected, (state, action) => {
      state.isSending = false;
      state.isLoading = false;
      state.error = action.payload;
      toast.error(action.payload?.message || "Failed to send OTP");
    });

    // Verify OTP
    builder.addCase(verifyReferralOtp.pending, (state) => {
      state.isVerifying = true;
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(verifyReferralOtp.fulfilled, (state, action) => {
      state.isVerifying = false;
      state.isLoading = false;
      state.referralData = action.payload;
      toast.success(verifyOtpSuccessMessage);
    });
    builder.addCase(verifyReferralOtp.rejected, (state, action) => {
      state.isVerifying = false;
      state.isLoading = false;
      state.error = action.payload;
      // toast.error(action.payload?.message || "Invalid OTP. Please try again");
    });

    // Fetch Referral Link
    builder.addCase(referralLink.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(referralLink.fulfilled, (state, action) => {
      state.isLoading = false;
      state.referralLink = action.payload?.referral_code;
      state.referralStatus = action.payload?.status;
    });
    builder.addCase(referralLink.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      debugLog("referralLink error:", action.payload);
      // toast.error(action.payload?.message || "Failed to fetch referral link");
    });

    // Fetch Referral Stats (earnings + history)
    builder.addCase(fetchReferralStats.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchReferralStats.fulfilled, (state, action) => {
      state.isLoading = false;
      state.totalReferralEarnings = action.payload.totalReferralEarnings;
      state.totalReferralCount = action.payload.totalReferralCount;
      state.referralHistory = action.payload.referralHistory;
    });
    builder.addCase(fetchReferralStats.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      debugLog("fetchReferralStats error:", action.payload);
    });

    // Resend OTP
    builder.addCase(resendReferralOtp.pending, (state) => {
      state.isResending = true;
      state.error = null;
    });
    builder.addCase(resendReferralOtp.fulfilled, (state) => {
      state.isResending = false;
      toast.success(sendOtpSuccessMessage);
    });
    builder.addCase(resendReferralOtp.rejected, (state, action) => {
      state.isResending = false;
      state.error = action.payload;
      toast.error(action.payload?.message || "Failed to resend OTP");
    });
  },
});

export const {
  clearReferralError,
  resetReferralState,
  setOtpValidate,
  setReferralHistory,
  setReferralLink,
  setReferralStatus,
} = referralSlice.actions;
export default referralSlice.reducer;
